export const TO_BOTH = 'to_both';
export const TO_TUTOR = 'to_tutor';
export const TO_STUDENT = 'to_student';



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/constants/pubnubRecipient.js